module.exports = __webpack_public_path__ + "img/213.5523de9a.png";